/**
 * The free trial: a Stripe-native trial period on the REAL Starter plan,
 * behind the `TRIAL_ENABLED` switch. The customer subscribes with a card,
 * pays nothing for CARD_TRIAL_DAYS, and on that day Stripe bills the plan as
 * normal. Isomorphic: the marketing band and billing page read these,
 * `trial.server.ts` decides eligibility.
 *
 * The 'no_card' kind is history: an in-house grant offered 2026-09-14 to
 * 2026-09-28 and withdrawn after it was farmed. Trials it started still run
 * out under `expireLapsedNoCardTrials`, so its claims and refs stay readable.
 */

export const TRIAL_PLAN_SLUG = 'starter'
/** The Stripe trial period, in days. */
export const CARD_TRIAL_DAYS = 30
/** 500 MB. Bytes, not GB, so the catalog stays whole-GB. */
export const TRIAL_ALLOWANCE_BYTES = 500_000_000
/** Days into a trial before the convert-before-it-ends nudge goes out. */
export const TRIAL_NUDGE_AFTER_DAYS = 20

export type TrialKind = 'card' | 'no_card'

/** What the public pages need to render the offer; null when it is off. */
export interface TrialOffer {
  kind: TrialKind
  /** True for the Stripe trial: the checkout collects a card up front. */
  requiresCard: boolean
  planSlug: string
  planName: string
  /** What the plan bills once the trial ends. */
  priceMonthlyMicroUsd: number
  allowanceBytes: number
  days: number
}

/** The in-house subscription ref a no-card trial cycle carries. */
export function trialSubscriptionRef(organizationId: string): string {
  return `trial:${organizationId}`
}

export function isTrialSubscriptionRef(
  ref: string | null | undefined,
): boolean {
  return !!ref && ref.startsWith('trial:')
}

/** "200 MB": the allowance as marketing prints it, whole MB, no decimals. */
export function formatTrialAllowance(bytes: number): string {
  return `${Math.round(bytes / 1_000_000)} MB`
}
